/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from 'react-transition-group'
import Notification from './Notification'
import { css } from 'emotion'


const fade = {
  entering: css`
    opacity: 0;
    position: absolute;
  `,
  entered: css`
    opacity: 1;
  `,
  exiting: css`
    opacity: 0;
    position: absolute;
  `,
}

const baseStyle = css`
  transition: opacity 300ms ease-in-out;
  @media only screen and (max-width: 960px) {
    margin-bottom: 16px;
  }
`

const InlineNotification = ({ show, ...props }) => (
  <Transition in={show} appear timeout={300}>
    {status => (
      <Notification {...props} className={`${baseStyle} ${fade[status]}`} />
    )}
  </Transition>
)

InlineNotification.propTypes = {
  show: PropTypes.bool.isRequired,
}

export default InlineNotification
